/* Legeldle – Aktuális ajánlat: visszaszámláló és időzített megjelenés (sections/legeldle-ajanlat.liquid).
   A beírt időpontot magyar idő szerint értelmezi (téli/nyári időszámítással), a látogató gépének óráját csak a "most"-hoz használja. */
(function () {
  if (window.customElements.get('lgd-ajanlat')) return;

  var ZONA = 'Europe/Budapest';
  var formazo = null;
  try {
    formazo = new Intl.DateTimeFormat('en-US', {
      timeZone: ZONA, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric'
    });
  } catch (e) {}

  // A magyar idő eltérése az UTC-től az adott pillanatban (ms)
  function eltolas(ms) {
    if (!formazo) return 3600000;
    var r = {};
    formazo.formatToParts(new Date(ms)).forEach(function (x) { r[x.type] = x.value; });
    return Date.UTC(+r.year, r.month - 1, +r.day, +r.hour % 24, +r.minute, +r.second) - ms;
  }

  // "2026-11-30 23:59", "2026.11.30. 23:59" vagy csak "2026-11-30" (= a nap vége)
  function ido(szoveg) {
    var m = String(szoveg || '').match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})(?:\D+(\d{1,2})(?:\D+(\d{1,2}))?)?/);
    if (!m) return null;
    var vanOra = m[4] != null;
    var helyi = Date.UTC(+m[1], m[2] - 1, +m[3], vanOra ? +m[4] : 23, vanOra ? +(m[5] || 0) : 59, vanOra ? 0 : 59);
    var t = helyi - eltolas(helyi);
    return helyi - eltolas(t);
  }

  function ket(n) { return n < 10 ? '0' + n : String(n); }

  class LgdAjanlat extends HTMLElement {
    connectedCallback() {
      this.vege = ido(this.dataset.vege);
      this.kezdes = ido(this.dataset.kezdes);
      this.szerk = this.dataset.szerkeszto === '1';
      this.csempek = {};
      var self = this;
      this.querySelectorAll('[data-egyseg]').forEach(function (el) { self.csempek[el.dataset.egyseg] = el; });
      this.frissit();
      if (this.vege || this.kezdes) this.idozito = setInterval(this.frissit.bind(this), 1000);
    }

    disconnectedCallback() { clearInterval(this.idozito); }

    allit(egyseg, ertek) {
      var el = this.csempek[egyseg];
      if (!el) return;
      var b = el.querySelector('b');
      var uj = ket(ertek);
      if (b.textContent === uj) return;
      b.textContent = uj;
      b.classList.remove('lgd-ajanlat__uj');
      void b.offsetWidth;
      b.classList.add('lgd-ajanlat__uj');
    }

    frissit() {
      var most = Date.now();
      var elotte = this.kezdes != null && most < this.kezdes;
      var lejart = this.vege != null && most >= this.vege;
      var szamlalo = this.querySelector('.lgd-ajanlat__szamlalo');

      if (!this.szerk) {
        this.hidden = elotte || (lejart && this.dataset.lejarat === 'elrejt');
        if (szamlalo) szamlalo.hidden = lejart;
      }
      var jegyzet = this.querySelector('[data-lgd-aj-szerk]');
      if (this.szerk && jegyzet && (elotte || lejart)) {
        jegyzet.hidden = false;
        jegyzet.querySelector('span').textContent = elotte ? 'Még nem kezdődött el, a vásárlók most nem látják.' :
          (this.dataset.lejarat === 'elrejt' ? 'Lejárt, a vásárlók már nem látják.' : 'Lejárt, a vásárlók a számláló nélkül látják.');
      }

      if (this.vege == null) return;
      var mp = Math.max(0, Math.floor((this.vege - most) / 1000));
      var nap = Math.floor(mp / 86400);
      this.allit('nap', nap);
      this.allit('ora', Math.floor((mp % 86400) / 3600));
      this.allit('perc', Math.floor((mp % 3600) / 60));
      this.allit('mp', mp % 60);
      if (this.csempek.nap) this.csempek.nap.hidden = nap === 0;
      if (lejart && !this.szerk) clearInterval(this.idozito);
    }
  }

  window.customElements.define('lgd-ajanlat', LgdAjanlat);
})();
